export default __webpack_public_path__ + "static/Leisha-McKinley-Beach-hero-d461647c2989e49c9c81d90f90f8f020.jpg";